import { supabase } from '../lib/supabaseClient';

export type ContactLead = {
  name: string;
  email: string;
  phone?: string;
  company?: string;
  service: string;
  message: string;
};

export async function submitContactLead(data: ContactLead) {
  if (!supabase) {
    throw new Error('Contact form backend is not configured yet. Please try again later.');
  }

  const { error } = await supabase.from('contact_leads').insert([data]);

  if (error) {
    throw new Error(error.message);
  }
}

